// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__icVtg","primary":"badge_primary__EK0c5","secondary":"badge_secondary__6nj1H"};